import {useLocation} from "react-router";
import {PageRefusal} from "@/components/ui/box";
import {inboxWords as words} from "./inbox-copy";
export function InboxRefusal({page="course-inbox"}:{page?:string}) {
  const location=useLocation();
  return <PageRefusal id={page} journey="inbox" refusal={{reason:"unavailable",sentence:words.selectionUnavailable,
    back:{label:words.returnInbox,to:location.pathname}}}/>;
}
